import React from 'react';

import TRANSLATIONS from './translations@default.json';

const SidebarHeading = () => {
	return (
		<div className="text-display-sm" data-testid="heading">
			{TRANSLATIONS.newHeading}
		</div>
	);
};

export default SidebarHeading;
